export const matrixOtherChange = (value, questionId) => ({
  type: 'OTHER_CHANGE',
  questionId,
  value,
});

export const matrixOtherBlur = questionId => ({
  type: 'OTHER_BLUR',
  questionId,
});

export const otherChange = (value, questionId) => ({
  type: 'OTHER_CHANGE',
  questionId,
  value,
});

export const otherBlur = questionId => ({
  type: 'OTHER_BLUR',
  questionId,
});
